import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeftOutlined,
  UserOutlined,
  PrinterOutlined,
  MailOutlined,
  PlusOutlined,
  FileTextOutlined,

} from "@ant-design/icons";
import {
  Card,
  Flex,
  Select,
  DatePicker,
  Row,
  Col,
  Form,
  Button,
  Typography,
  Input,
  Space,
  Modal,
} from "antd";

import { EnquiryService } from "../../../Services/Manage/EnquiryService";
import { UserService } from "../../../Services/Manage/UserService";
import useMessage from "antd/es/message/useMessage";
import ListEqData from "./ListEqData";
import AddQuotationData from "./AddQuotationData";
import { QuotationService } from "../../../Services/Manage/QuotationService";
import dayjs from "dayjs";
import DropdownBtn from "../../general/DropdownBtn";
import CustomerDetails from "../Enquiry/CustomerDetails";

const { TextArea } = Input;

const CreateQuotation = () => {

  const primaryColor = "rgba(11, 93, 148, 0.95)";
  const [data, setData] = useState([]);
  const [message, msgConxt] = useMessage();
  const [eqData, setEqData] = useState([]);
  const [qu_gen, setQu_gen] = useState("");
  const [Eqslected, seEQSelect] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [followDate, setFollowDate] = useState("");
  const addQuotationRef = useRef(null);
  const navigate = useNavigate();
  const [validDate, setValidDate] = useState("");




  const [emailModalOpen, setEmailModalOpen] = useState(false);


  const [emailData, setEmailData] = useState({
    to: "",
    subject: "",
    message: "",
  });

  const [preparedBy, setPreparedBy] = useState("");

  const [followUps, setFollowUps] = useState([
    {
      current_date: dayjs().format("YYYY-MM-DD"),
      date: null,
      summary: "",
    },
  ]);

  const [customerForm] = Form.useForm();

  const [quotationStatus, setQuotationStatus] = useState("Draft");

  const getAllCompletedEnquiry = async () => {
    try {
      const user = await UserService.getOmeUser();
      let viewAll = false;
      try {
        const raw = localStorage.getItem("ome_permission");
        const parsed = JSON.parse(raw);
        const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
        const p = permissions.find((x) => x.link === "/enquiry");
        viewAll = p?.view_all === true;
      } catch { }

      const request = await EnquiryService.getAllEnquiries();
      let rows = request.data || [];

      if (!viewAll) {
        const omeUser = JSON.parse(localStorage.getItem("ome_user") || "{}");
        const userName = omeUser?.name || omeUser?.user_name || "";
        rows = rows.filter(d => {
          const assigned = (d.assigned_to || "").split(',').map(s => s.trim()).filter(Boolean);
          const isAssigned = assigned.includes(userName);
          const isCreator = String(d.addedby ?? "").trim() === String(user.uid).trim();
          return isAssigned || isCreator;
        });
      }

      // filter only move_to_quotation statuses (active enquiries)
      const { ConfigurationService } = await import('../../../Services/Manage/ConfigurationService');
      const res = await ConfigurationService.getByType("enquiry_status");
      const moveToQuotationStatuses = (res.data || [])
        .filter(s => s.move_to_quotation)
        .map(s => s.label.trim());

      rows = rows.filter(d => moveToQuotationStatuses.includes((d.eq_status || "").trim()));

      setData(rows);
    } catch (error) {
      console.error(error);
    }
  };

  const getLoggedInUser = async () => {
    try {
      const user = await UserService.getOmeUser();

      setPreparedBy(
        user?.name ||
        user?.full_name ||
        user?.username ||
        user?.uid ||
        "Admin"
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllCompletedEnquiry();
    handleGenerateQu();
    getLoggedInUser();
  }, []);

  const handleGetDatabyEqid = async (value) => {
    try {
      const request = await EnquiryService.getEnquiryDetailsById(value);

      if (request.status) {
        message.success(request.message);
        setEqData(request.data);
        seEQSelect(true);

        const newQuNumber = await handleGenerateQu();
        setQu_gen(newQuNumber);
      } else {
        message.error(request.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleGenerateQu = async () => {
    try {
      const request = await QuotationService.getAllQuotationLast();

      const now = new Date();
      const currentMonth = String(now.getMonth() + 1).padStart(2, "0");
      const currentYear = String(now.getFullYear()).slice(-2);

      let newQuNumber = `${currentMonth}${currentYear}-001`;

      if (request?.data && request.data.qu_no) {
        const lastQuNo = request.data.qu_no;
        const [monthYearPart, sequencePart] = lastQuNo.split("-");

        if (monthYearPart && sequencePart) {
          const lastMonth = monthYearPart.slice(0, 2);
          const lastYear = monthYearPart.slice(2);

          if (lastMonth === currentMonth && lastYear === currentYear) {
            const sequenceNum = parseInt(sequencePart, 10);
            const newSequence = String(sequenceNum + 1).padStart(3, "0");
            newQuNumber = `${currentMonth}${currentYear}-${newSequence}`;
          }
        }
      }

      setQu_gen(newQuNumber);
      return newQuNumber;
    } catch (error) {
      console.error("Error generating quotation number:", error);

      const now = new Date();
      const currentMonth = String(now.getMonth() + 1).padStart(2, "0");
      const currentYear = String(now.getFullYear()).slice(-2);
      const fallbackQuNo = `${currentMonth}${currentYear}-001`;

      setQu_gen(fallbackQuNo);
      return fallbackQuNo;
    }
  };



  const handleNewQuotation = () => {
    setEqData({});
    seEQSelect(false);

    setFollowDate("");
    setValidDate("");
    setSelectedDate(dayjs().format("YYYY-MM-DD"));

    setQuotationStatus("Draft");

    customerForm.resetFields();

    const currentQu = qu_gen || "0000-000";

    const [monthYear, seq] = currentQu.split("-");

    const nextSeq = String(Number(seq || 0) + 1).padStart(3, "0");

    const nextQuNo = `${monthYear}-${nextSeq}`;

    setQu_gen(nextQuNo);

    addQuotationRef.current?.resetForm?.();
  };



  return (
    <>
      {msgConxt}

      <Card
        style={{
          borderRadius: 12,
          marginBottom: 12,
        }}
        bodyStyle={{ padding: 16 }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            marginBottom: 18,
            flexWrap: "wrap",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <ArrowLeftOutlined
              style={{
                cursor: "pointer",
                fontSize: 18,
                color: "#111827",
              }}
              onClick={() => window.history.back()}
            />

            <Typography.Text
              style={{
                color: "rgba(11, 93, 148, 0.95)",
                fontWeight: 700,
                fontSize: 16,
              }}
            >
              Create Quotation
            </Typography.Text>

            <Typography.Text style={{ color: "#9ca3af" }}>/</Typography.Text>

            <Typography.Text
              style={{
                color: "rgba(11, 93, 148, 0.95)",
                fontWeight: 800,
                fontSize: 16,
              }}
            >
              {qu_gen || "New Quotation"}
            </Typography.Text>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
            }}
          >
            <Button
              icon={<PrinterOutlined />}
              onClick={() => addQuotationRef.current?.handlePrintInvoice("professional")}
            >
              Print PDF
            </Button>
       <Button icon={<MailOutlined />} onClick={() => addQuotationRef.current?.handleSendQuotationEmail()}>
              Send Email
            </Button>
            {/* <DropdownBtn /> */}
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleNewQuotation}
              style={{
                backgroundColor: "rgba(11, 93, 148, 0.95)",
                borderColor: "rgba(11, 93, 148, 0.95)",
              }}
            >
              New Quotation
            </Button>
          </div>
        </div>

        {/* Quotation Information */}
        <div
          style={{
            border: "1px solid #eef0f5",
            borderRadius: 10,
            padding: "5px 18px 18px",
            background: "#fff",
            marginBottom: 16,
          }}
        >
          <Typography.Title
            level={5}
            style={{
              margin: "0 0 18px",
              fontWeight: 600,
              fontSize: 16,
              color: "rgba(11, 93, 148, 0.95)",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <FileTextOutlined />
            Quotation Information
          </Typography.Title>

          <Row gutter={[24, 18]}>
            <Col xs={24} sm={12} md={5}>
              <InfoItem label="Quotation No" value={qu_gen || "-"} />
            </Col>

            <Col xs={24} sm={12} md={4}>
              <InfoItem label="Revision No" value="R1" />
            </Col>

            <Col xs={24} sm={12} md={5}>
              <div>
                <div
                  style={{
                    color: "#6b7280",
                    fontSize: 12,
                    fontWeight: 600,
                    marginBottom: 4,
                  }}
                >
                  Quotation Date
                </div>

                <DatePicker
                  size="small"
                  format="DD MMM YYYY"
                  style={{ width: "100%", height: 32 }}
                  value={selectedDate ? dayjs(selectedDate) : null}
                  onChange={(value) =>
                    setSelectedDate(value ? dayjs(value).format("YYYY-MM-DD") : "")
                  }
                />
              </div>
            </Col>

            <Col xs={24} sm={12} md={5}>
              <div>
                <div
                  style={{
                    color: "#6b7280",
                    fontSize: 12,
                    fontWeight: 600,
                    marginBottom: 4,
                  }}
                >
                  Valid Until
                </div>

                <DatePicker
                  size="small"
                  format="DD MMM YYYY"
                  style={{ width: "100%", height: 32 }}
                  value={validDate ? dayjs(validDate) : null}
                  onChange={(value) =>
                    setValidDate(value ? dayjs(value).format("YYYY-MM-DD") : "")
                  }
                />
              </div>
            </Col>

            <Col xs={24} sm={12} md={5}>
              <InfoItem
                label="Status"
                value={
                  <span
                    style={{
                      background: "#e0edff",
                      color: "#2563eb",
                      padding: "6px 12px",
                      borderRadius: 6,
                      fontWeight: 700,
                    }}
                  >
                    {quotationStatus}
                  </span>
                }
              />
            </Col>

            <Col xs={24} sm={12} md={5}>
              <div>
                <div
                  style={{
                    color: "#6b7280",
                    fontSize: 12,
                    fontWeight: 600,
                    marginBottom: 4,
                  }}
                >
                  Enquiry Reference
                </div>

                <Select
                  size="small"
                  showSearch
                  allowClear
                  placeholder="Select Enquiry"
                  value={eqData?.eq_id || undefined}
                  onChange={handleGetDatabyEqid}
                  onClear={() => {
                    setEqData({});
                    seEQSelect(false);
                  }}
                  optionFilterProp="children"
                  style={{ width: "100%" }}
                >

                  {data.map((item) => (
                    <Select.Option key={item.eq_id} value={item.eq_id}>
                      {item.eq_id} - {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </Col>

            <Col xs={24} sm={12} md={4}>
              <InfoItem
                label="Lead Source"
                value={eqData?.eq_source || eqData?.lead_source || "-"}
              />
            </Col>

            <Col xs={24} sm={12} md={5}>
              <InfoItem
                label="Prepared By"
                value={preparedBy || "-"}
              />
            </Col>

            <Col xs={24} sm={12} md={5}>
              <InfoItem
                label="Assigned To"
                value={eqData?.assigned_to || eqData?.added_by || "-"}
              />
            </Col>

            <Col xs={24} sm={12} md={5}>
              <div>
                <div
                  style={{
                    color: "#6b7280",
                    fontSize: 12,
                    fontWeight: 600,
                    marginBottom: 4,
                  }}
                >
                  Expected Close Date
                </div>

                <DatePicker
                  size="small"
                  format="DD MMM YYYY"
                  style={{
                    width: "100%",
                    height: 32,
                  }}
                  value={followDate ? dayjs(followDate) : null}
                  onChange={(value) =>
                    setFollowDate(
                      value ? dayjs(value).format("YYYY-MM-DD") : null
                    )
                  }
                />
              </div>
            </Col>
          </Row>
        </div>

        {/* Same page boxes */}
        <div>
          <ListEqData
            data={eqData}
            setEqData={setEqData}
            mode="create"
            enquirySelected={Eqslected}
          />
        </div>

        <div style={{ marginTop: 16 }}>
          <AddQuotationData
            ref={addQuotationRef}
            Eqslected={Eqslected}
            enquiryList={data}
            data={qu_gen}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            validDate={validDate}
            followDate={followDate}
            quotationStatus={quotationStatus}
            eqData={eqData}
            handleGetDatabyEqid={handleGetDatabyEqid}
            customerForm={customerForm}
            preparedBy={preparedBy}
            assignedTo={eqData?.assigned_to || eqData?.added_by || ""}

          />
        </div>

        <Card
          style={{
            marginTop: 16,
            borderRadius: 12,
          }}
          bodyStyle={{
            padding: "6px 16px", // very small top & bottom padding
          }}
        >
          <Row align="middle" justify="space-between" wrap>
            {/* Left Buttons */}
            <Col>
              <Space>
                <Button icon={<ArrowLeftOutlined />}>
                  Back
                </Button>

                <Button
                  onClick={() => {
                    message.warning("Please save the draft before duplicating the quotation");
                  }}
                >
                  Duplicate
                </Button>
              </Space>
            </Col>

            {/* Status Flow */}
            <Col flex="auto">
              <div
                style={{
                  maxWidth: 650,
                  margin: "0 auto",
                }}
              >
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: "#374151",
                    marginBottom: 4,
                  }}
                >
                  Quotation Status Flow
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: 6,
                    flexWrap: "wrap",
                  }}
                >
                  {[
                    "Draft",
                    "Reviewed",
                    "Sent",
                    "Viewed",
                    "Negotiation",
                    "Approved",
                    "Converted",
                  ].map((item) => (
                    <div
                      key={item}
                      onClick={() => setQuotationStatus(item)}
                      style={{
                        cursor: "pointer",
                        minWidth: 78,
                        textAlign: "center",
                        padding: "7px 12px",
                        borderRadius: 6,
                        border:
                          quotationStatus === item
                            ? `1px solid ${primaryColor}`
                            : "1px solid #e5e7eb",
                        background:
                          quotationStatus === item
                            ? "rgba(11, 93, 148, 0.10)"
                            : "#fafafa",
                        color:
                          quotationStatus === item
                            ? primaryColor
                            : "#6b7280",
                        fontWeight: 600,
                        fontSize: 12,
                      }}
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </Col>

            {/* Right Buttons */}
            <Col>
              <Space>
                <Button
                  style={{
                    borderColor: primaryColor,
                    color: primaryColor,
                  }}
                  onClick={async () => {
                    const result = await addQuotationRef.current?.handleSave();

                    if (result?.status || result === true) {
                      navigate("/quotation");
                    }
                  }}

                >
                  Save Draft
                </Button>

                <Button
                  type="primary"
                  icon={<MailOutlined />}
                  style={{
                    background: primaryColor,
                    borderColor: primaryColor,
                  }}
                  onClick={() => addQuotationRef.current?.handleSendQuotationEmail()}
                >
                  Send Email
                </Button>
                <Button
                  type="primary"
                  style={{
                    background: primaryColor,
                    borderColor: primaryColor,
                  }}
                >
                  Convert to Project
                </Button>
              </Space>
            </Col>
          </Row>
        </Card>



      </Card>


      <Modal
        title="Send Quotation Email"
        open={emailModalOpen}
        onCancel={() => setEmailModalOpen(false)}
        onOk={() => {
   

          // call API here
          // QuotationService.sendEmail(emailData);

          setEmailModalOpen(false);
        }}
      >
        <Form layout="vertical">
          <Form.Item label="To">
            <Input
              value={emailData.to}
              onChange={(e) =>
                setEmailData((p) => ({
                  ...p,
                  to: e.target.value,
                }))
              }
            />
          </Form.Item>

          <Form.Item label="Subject">
            <Input
              value={emailData.subject}
              onChange={(e) =>
                setEmailData((p) => ({
                  ...p,
                  subject: e.target.value,
                }))
              }
            />
          </Form.Item>

          <Form.Item label="Message">
            <Input.TextArea
              rows={6}
              value={emailData.message}
              onChange={(e) =>
                setEmailData((p) => ({
                  ...p,
                  message: e.target.value,
                }))
              }
            />
          </Form.Item>
        </Form>
      </Modal>



    </>
  );
};

const InfoItem = ({ label, value }) => (
  <div>
    <div
      style={{
        color: "#6b7280",
        fontSize: 12,
        fontWeight: 600,
        marginBottom: 4,
      }}
    >
      {label}
    </div>

    <div
      style={{
        color: "#111827",
        fontSize: 14,
        fontWeight: 700,
        lineHeight: 1.5,
        minHeight: 24,
      }}
    >
      {value || "-"}
    </div>
  </div>
);

export default CreateQuotation;